<template>
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.80474 0.20921C8.06509 0.488156 8.06509 0.940417 7.80474 1.21936L4.4714 4.79079C4.21105 5.06974 3.78894 5.06974 3.5286 4.79079L0.195262 1.21936C-0.0650883 0.940416 -0.0650883 0.488155 0.195262 0.209209C0.455611 -0.0697368 0.877722 -0.0697368 1.13807 0.209209L4 3.27556L6.86193 0.20921C7.12228 -0.0697362 7.54439 -0.0697362 7.80474 0.20921Z"
      fill="#AFAFBE"
    />
  </svg>
</template>
